import type { TerminationRequestSummary } from '../dtos/termination';

export class TerminationRequest {
  readonly id: number;
  readonly merchantId: string;
  readonly status: 'PENDING' | 'APPROVED' | 'REJECTED';
  readonly createdAt: string;
  readonly decisionedAt: string | null;
  readonly createdByName: string;
  readonly createdByEmail: string;
  readonly decisionedByName: string | null;

  constructor(params: Partial<TerminationRequest> & { id?: number }) {
    this.id = params.id ?? 0;
    this.merchantId = params.merchantId ?? '';
    this.status = params.status ?? 'PENDING';
    this.createdAt = params.createdAt ?? '';
    this.decisionedAt = params.decisionedAt ?? null;
    this.createdByName = params.createdByName ?? '';
    this.createdByEmail = params.createdByEmail ?? '';
    this.decisionedByName = params.decisionedByName ?? null;
  }

  get isPending(): boolean {
    return this.status === 'PENDING';
  }
}

export const TerminationRequestMapper = {
  fromDto(dto: TerminationRequestSummary): TerminationRequest {
    return new TerminationRequest({
      id: dto.id,
      merchantId: dto.merchantId,
      status: dto.status,
      createdAt: dto.createdAt,
      decisionedAt: dto.decisionedAt,
      createdByName: dto.createdBy?.name ?? '',
      createdByEmail: dto.createdBy?.email ?? '',
      decisionedByName: dto.decisionedBy?.name ?? null,
    });
  },

  fromDtoList(dtos: TerminationRequestSummary[]): TerminationRequest[] {
    return (dtos ?? []).map((dto) => TerminationRequestMapper.fromDto(dto));
  },
};
